import type { LegacyRef, MutableRefObject, RefCallback } from 'react'

// Combine multiple refs into one.
export function mergeRefs<T = unknown>(
  ...refs: (MutableRefObject<T | null> | LegacyRef<T> | null | undefined)[]
): RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value)
        return
      }

      if (ref && typeof ref === 'object') {
        ;(ref as React.MutableRefObject<T | null>).current = value
      }
    })
  }
}
